import { useState, useEffect } from 'react';
import { onSnapshot, doc } from 'firebase/firestore';
import { db } from '@/firebase';

export interface WeatherData {
  location: string;
  temp: number;
  description: string;
  icon: string;
}

export interface EventWeatherData extends WeatherData {
  eventTitle: string;
}

export interface CalendarEventBrief {
  eventId: string;
  title: string;
  start: string;
  end: string;
  location?: string;
}

export interface TaskBrief {
  taskId: string;
  title: string;
  status: string;
  dueDate?: string;
}

export interface StoicQuote {
  text: string;
  author: string;
}

export interface DailyBrief {
  narrative: string;
  events: CalendarEventBrief[];
  tasks: TaskBrief[];
  suggestions: TaskBrief[];
  homeWeather: WeatherData | null;
  eventWeather: EventWeatherData[];
  stoicQuote: StoicQuote | null;
  commuteEstimate: string | null;
  generatedAt: any;
  date: string;
}

export function useDailyBrief(uid: string | null): { brief: DailyBrief | null; loading: boolean } {
  const [brief, setBrief] = useState<DailyBrief | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!uid) {
      setBrief(null);
      setLoading(false);
      return;
    }

    const unsubscribe = onSnapshot(
      doc(db, 'users', uid, 'brief', 'today'),
      (snap) => {
        if (snap.exists()) {
          setBrief(snap.data() as DailyBrief);
        } else {
          setBrief(null);
        }
        setLoading(false);
      },
      (err) => {
        console.error('useDailyBrief error:', err);
        setLoading(false);
      }
    );

    return unsubscribe;
  }, [uid]);

  return { brief, loading };
}
